import { createSelector } from 'reselect';

import { getPaging, mountSelectorAt, getTextEditing } from 'utils/selectors';

const mount = mountSelectorAt('comments');

export const getCommentsIds = mount((localState, props) => {
  const { queryString, page, live } = props;

  if(live) {
    return localState.live.list;
  }

  const pagesForQuery = localState.byQuery[queryString];
  if(!pagesForQuery) return [];

  const commentsIds = pagesForQuery.byPage[page];
  if(!commentsIds) return [];

  return commentsIds;
});

export const getCommentsById = mount(localState => localState.byId);

export const getComments = createSelector(
  [getCommentsIds, getCommentsById],
  (commentsIds, commentsById) => {

  return commentsIds.map(commentId => commentsById[commentId]);
});

export const getNewestLiveComment = mount((localState, rootState) => {
  const comments = getComments(rootState, {live: true});
  return comments.length > 0 ? comments[0] : null;
});

export const getOldestLiveComment = mount((localState, rootState) => {
  const comments = getComments(rootState, {live: true});
  return comments.length > 0 ? comments[comments.length - 1] : null;
});

export const getCommentsIsLiveListEndReached = mount(localState => localState.live.endReached);

export const getCommentLiveListLastApprovedTime = mount((localState, rootState) => getNewestLiveComment(rootState) || 0);

export const getCommentsPaging = mount((localState, key, options) => getPaging(localState.paging, options));

export const getNestedCommentsPagingState = mount(localState => localState.paging.byQuery);

export const getCommentsTextEditing = mount((localState, key) => getTextEditing(localState.textEditing[key]));

export const getCommentsEmojis = mount((localState, key) => localState.emojis[key]);

export const getCommentById = mount((localState, id) => localState.byId[id]);

export const getCommentsSort = mount(localState => localState.sort);



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/selectors.js
 **/